
import "./PaymentDescriptionListItem.css";

export default function PaymentDescriptionListItem({
    title,
    date,
    description,
    value,
    totalValue
}) {
    return (
        <div className="PaymentDescriptionListItem">

            <div className="PaymentDescriptionListItem__header">
                <span className="PaymentDescriptionListItem__title">
                    {title}
                </span>
                <span className="PaymentDescriptionListItem__date">
                    {date}
                </span>
            </div>
            <div className="PaymentDescriptionListItem__description">
                {description}
            </div>
            <div className="PaymentDescriptionListItem__line">
                <div className="PaymentDescriptionListItem__label">
                    Penalização
                </div>
                <div className="PaymentDescriptionListItem__value">
                    {value}
                </div>
            </div>

            <div className="PaymentDescriptionListItem__line">
                <div className="PaymentDescriptionListItem__total">
                    Total
                </div>
                <div className="PaymentDescriptionListItem__total__value">
                    {totalValue}
                </div>
            </div>
        </div>
    );
}